export const SALEOR_GITHUB_URL = "https://github.com/saleor/saleor";
export const SALEOR_DISCORD_URL = "https://saleor.io/discord";
export const TECHNICAL_HELP_CTA_URL =
  "https://www.getclockwise.com/c/rian-dillon-saleor-io/short-call-with-saleor";
export const APPS_DOCS_URL = "https://docs.saleor.io/developer/extending/apps/overview";
export const CHECKOUT_DOCS_URL = "https://docs.saleor.io/developer/checkout/overview#introduction";
export const DASHBOARD_DOCS_URL = "https://github.com/saleor/saleor-dashboard/releases";
